<template>
	<v-dialog v-model="dialogUser" max-width="800px" persistent>
		<v-card>
			<v-card-title>
				<span class="headline">Editar meu dados</span>
			</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.nome"
									label="Nome"
									:rules="[rules.required, rules.min2]"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.email"
									label="E-mail"
									:rules="[rules.required, rules.min2, rules.email]"
									type="email"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.telefone"
									label="Telefone"
									v-mask="['(##) ####-####', '(##) #####-####']"
									maxlength="15"
									:rules="[rules.required]"
									type="tel"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.cpf"
									label="CPF"
									v-mask="'###.###.###-##'"
									maxlength="14"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									label="Alterar a senha"
									prepend-icon="fal fa-lock-alt"
									:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
									:type="showPassword ? 'text' : 'password'"
									@click:append="showPassword = !showPassword"
									v-model="codigo"
									placeholder="Digite sua nova senha"
									autocomplete="off"
								>
								</v-text-field>
							</v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="warning" icon @click="close()" title="Fechar formulário">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
				<v-btn color="success" icon @click="save()" title="Salvar formulário">
					<v-icon>fal fa-save</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	inheritAttrs: false,
	props: {
		userEdit: undefined,
	},
	data() {
		return {
			server: 'user',
			showPassword: false,
			editedItem: {},
			codigo: null,
		}
	},
	computed: {
		...mapState(['user', 'rules', 'dialogUser'])
	},
	created() {
		this.editedItem = Object.assign({}, this.userEdit)
		setTimeout(() => {
			this.codigo = null
		}, 1700)
	},
	methods: {
		close() {
			this.$store.dispatch('dialogUser', { value: false })
			setTimeout(() => {
				this.$emit('changeTypeForm', { hideForm: 'user' })
			}, 300)
		},
		save() {
			if (this.$refs.form.validate()) {
				
				let formData = new FormData()
				formData.append('menu', this.server)
				formData.append('function', 'update_one_' + this.server)
				formData.append('user_id', this.user.id)
				formData.append('id', this.editedItem.id)
				formData.append('nome', this.editedItem.nome)
				formData.append('cpf', this.editedItem.cpf)
				formData.append('email', this.editedItem.email)
				formData.append('telefone', this.editedItem.telefone)
				formData.append('codigo', this.codigo)
				let vd = this
				this.$axiosPost
					.post('functions.php', formData, {
						headers: { Authorization: this.user.token },
					})
					.then(function(response) {
						if (response.data.error === 0) {
							vd.close()
							vd.$store.dispatch('alert', {
								alertMessage: response.data.alertMessage,
								alertType: 0,
							})
							vd.$store.dispatch('searchUser', { value: true })
						} else {
							vd.$store.dispatch('errorServer', {
								data: response.data,
								destination: vd.$route.path,
							})
						}
					})
					.catch(function(response) {
						console.log('ERROR!! ' + response)
					})
			}
		},
	},
}
</script>
